exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-custom-scrollbar{position:relative;height:200px;overflow:overlay}.table-wrapper-scroll-y{display:compact}#scrollableDiv{height:100px;overflow-y:scroll;border:1px solid #ccc;padding:10px;border-radius:10px;margin:10px 0}.content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}button{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ee144f3","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/user/station_list.vue
// module id = B2sB
// module chunks = 113